import {ReduxState, Record, Identifier,useLocale} from 'react-admin';
// import { useStore } from 'react-admin';
export default function Types() {

    return {
        'default_locale':'en'
    };
}